import { sanitizeHtml } from "./safeContent";
import "./richContent.css";
export default function SafeHtml({
  html,
  className = "",
  ...props
}) {
  const clean = sanitizeHtml(html);
  if (!clean) return null;
  return <div {...props} className={`cabinet-rich-text ${className}`} dangerouslySetInnerHTML={{
    __html: clean
  }} />;
}
